import {type IAsset} from '../schema';
import {isDocumentFileTypeAsset} from '../utils';

export const assetHasConstituentPages = (asset?: IAsset): asset is IAsset => {
	return (
		!!asset &&
		isDocumentFileTypeAsset(asset.fileFormatFamily) &&
		asset.constituentIds.length > 0
	);
};
